var _LoaderWrapper;
import { lazy, Suspense } from "react";
import { useMediaQuery } from "@crehana/react-hooks";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Loader } from "@crehana/ui";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { keyframes } from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
var LazyLoginRegisterSwitcherDialog = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: "login-register-modal" */"./LoginRegisterSwitcherDialog");
});
var fadeIn = /*#__PURE__*/keyframes(["\n  from {\n    opacity: 0;\n  } to {\n    opacity: 1;\n  }\n"]);
var LoaderWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-q1arqo-0"
})(["\n  background-color: rgba(0, 0, 0, 0.85) !important;\n  animation: ", " 225ms ease-in-out forwards;\n"], fadeIn);
var AuthDialog = function AuthDialog(_ref) {
  var dialogProps = _ref.dialogProps,
    formState = _ref.formState,
    loginRegisterSwitcherProps = _ref.loginRegisterSwitcherProps,
    closeAuthenticateModal = _ref.closeAuthenticateModal,
    showNameFields = _ref.showNameFields,
    showCustomAffiliateAside = _ref.showCustomAffiliateAside;
  var _useMediaQuery = useMediaQuery('md'),
    isDesktop = _useMediaQuery.matches;
  var isMobile = !isDesktop;
  if (!formState.loginRegisterModalMounted) {
    return null;
  }
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: _LoaderWrapper || (_LoaderWrapper = /*#__PURE__*/_jsx(LoaderWrapper, {
      className: "fixed inset-0 flex items-center justify-center w-screen h-screen",
      children: /*#__PURE__*/_jsx(Loader, {})
    })),
    children: /*#__PURE__*/_jsx(LazyLoginRegisterSwitcherDialog, {
      open: formState.showModal,
      onRequestClose: closeAuthenticateModal,
      fullScreen: isMobile,
      currentForm: formState.currentForm,
      registerTitle: formState.customMessages && formState.customMessages.registerTitle,
      registerMessage: formState.customMessages && formState.customMessages.registerMessage,
      loginRegisterSwitcherProps: loginRegisterSwitcherProps,
      dialogProps: dialogProps || {},
      showNameFields: showNameFields,
      showCustomAffiliateAside: showCustomAffiliateAside
    })
  });
};
export default AuthDialog;